import { render, staticRenderFns } from "./comprovante.vue?vue&type=template&id=389f1f74"
import script from "./comprovante.vue?vue&type=script&lang=js"
export * from "./comprovante.vue?vue&type=script&lang=js"
import style0 from "./comprovante.vue?vue&type=style&index=0&id=389f1f74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports